import React, { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

function DeleteDialog({
  isVisible = false,
  setIsVisible,
  element,
  itemIdx,
  deleteAction,
}) {
  const [open, setOpen] = useState(isVisible);
  const content = `Please confirm delete ${element} on this device. \n
    This action cannot be undone!`;

  const handleConfirm = () => {
    deleteAction(itemIdx);
    setIsVisible(false);
    setOpen(false);
  };

  const handleCancel = (e) => {
    setIsVisible(false);
    setOpen(false);
  };

  return (
    <div>
      {/* Dialog that is displayed if the state open is true */}
      <Dialog
        open={open || isVisible}
        onClose={handleCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`Delete ${element}`}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{content}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" onClick={handleCancel}>
            Cancel
          </Button>
          <Button variant="contained" color="secondary" onClick={handleConfirm} autoFocus>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default DeleteDialog;
